export type TNativeAudioWorkletNodeOptions = AudioWorkletNodeOptions;
